import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import SortableTable from "../Components/SortableTable";
import { showPopupSnackbar } from "../redux/actions/snackbarActions";
import { getToken } from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";
import { useStyles } from "../Utils/Styles";

const server = EnvSettings.server;

function formatUserData(data) {
  var arr = [];
  data.forEach((element) => {
    arr.push({
      id: element.id,
      userName: element.userName,
      emailAddress: element.emailAddress,
      permissionLevel: element.permissionLevel,
      fullName: element.fullName,
      companyName: element.Company ? element.Company.companyName : "",
    });
  });
  return arr;
}

export default function Users(props) {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const [users, setUsers] = useState();
  const dispatch = useDispatch();
  let getUsers = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken() }),
    };
    fetch(server + "/get_user_list", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          setUsers(formatUserData(result.users));
        }
      });
  };

  let showUser = (id) => {
    history.push("/cpanel/users/" + id);
  };

  useEffect(getUsers, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Button
            onClick={() => {
              history.push("/cpanel/users/new");
            }}
          >
            {t("users.newUser")}
          </Button>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          {users ? (
            <SortableTable
              data={{
                headCells: [
                  {
                    id: "userName",
                    numeric: false,
                    disablePadding: false,
                    label: t("userList.username"),
                  },
                  {
                    id: "emailAddress",
                    numeric: false,
                    disablePadding: false,
                    label: t("userList.email"),
                  },
                  {
                    id: "permissionLevel",
                    numeric: false,
                    disablePadding: false,
                    label: t("userList.permissionLevel"),
                  },
                  {
                    id: "fullName",
                    numeric: false,
                    disablePadding: false,
                    label: t("userList.name"),
                  },
                  {
                    id: "companyName",
                    numeric: false,
                    disablePadding: false,
                    label: t("userList.company"),
                  },
                ],
                defaultSortRow: "userName",
                handleRowClick: showUser,
                tableData: users,
                rowsPerPage: 25,
              }}
            />
          ) : undefined}
        </Paper>
      </Grid>
    </Grid>
  );
}
